import { render } from "./SignUpPromo.vue?vue&type=template&id=f1af4a58&scoped=true"
import script from "./SignUpPromo.vue?vue&type=script&lang=js"
export * from "./SignUpPromo.vue?vue&type=script&lang=js"

import "./SignUpPromo.vue?vue&type=style&index=0&id=f1af4a58&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f1af4a58"

export default script